<template>
  <a-card class="style1">
    <h3 class="pb-2">Moderators</h3>
    <a-table :loading="isLoading" :columns="columns" :data-source="userData" size="middle" bordered rowKey="id">
      <div slot="role" slot-scope="text">{{ getRoleInfo(text) }}</div>
      <div slot="fullname" slot-scope="text, record">
        {{ getFullName(record) }}
      </div>
      <div slot="created_at" slot-scope="text, record">
        {{ getCreatedAt(record) }}
      </div>
      <div slot="signature" slot-scope="text, record">
        <a :href="record.moderator.signature" download="signature.png">
          <a-icon type="download" />
        </a>
      </div>
      <div slot="phone_number" slot-scope="text, record">
        {{ record.moderator.phone_number }}
      </div>
      <div slot="level" slot-scope="text, record">
        <a-select :default-value="record.moderator.level" :showArrow="false" @change="e => handleLevelChange(e, record)" style="min-width: 120px;">
          <a-select-option v-for="(ml, index) in moderatorLevel" :value="ml.value" :key="index">
            {{ ml.text }}
          </a-select-option>
        </a-select>
      </div>
      <div slot="status" slot-scope="text, record">
        <a-select
          :default-value="record.moderator.status"
          :showArrow="false"
          @change="e => handleStatusChange(e, record)"
          style="min-width: 120px;"
          :class="`select-status-${record.moderator.id} select-value-${record.moderator.status}`"
        >
          <a-select-option v-for="(ms, index) in moderatorStatus" :value="ms.value" :key="index" :class="`select-option-${ms.value}`">
            {{ ms.text }}
          </a-select-option>
        </a-select>
      </div>
      <div slot="action" slot-scope="record" class="action">
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </div>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>
  </a-card>
</template>
<script>
import { slugData, empty } from '@/utils';
import { includes, replace, map } from 'lodash';
import moment from 'moment';
import AdminService from '@/services/AdminService';
export default {
  data() {
    const roleInfo = [
      { text: 'Admin', value: 'admin' },
      { text: 'Care', value: 'care' },
      { text: 'Disciple', value: 'disciple' },
      { text: 'Evangelism', value: 'evangelism' },
      { text: 'Individual', value: 'individual' },
    ];

    const moderatorLevel = [
      { text: 'Moderator 1', value: 'level_1' },
      { text: 'Moderator 2', value: 'level_2' },
    ];

    const moderatorStatus = [
      { text: 'Under review', value: 'review' },
      { text: 'Approve', value: 'approved' },
      { text: 'Decline', value: 'declined' },
    ];
    return {
      form: this.$form.createForm(this),
      moderatorList: [],
      searching: '',
      error: '',
      isLoading: true,
      userData: [],
      moderatorLevel,
      moderatorStatus,
      roleInfo: map(roleInfo, item => ({ label: item.text, value: item.value })),
      columns: [
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
        },
        {
          title: 'Full Name',
          dataIndex: 'fullname',
          key: 'fullname',
          scopedSlots: {
            customRender: 'fullname',
          },
        },
        {
          title: 'Phone Number',
          dataIndex: 'phone_number',
          key: 'phone_number',
          scopedSlots: {
            customRender: 'phone_number',
          },
          onFilter: (value, record) => includes(record.moderator.phone_number, value),
        },
        {
          title: 'Role',
          dataIndex: 'role',
          key: 'role',
          scopedSlots: {
            customRender: 'role',
          },
          filters: roleInfo,
          onFilter: (value, record) => includes(record.role, value),
        },
        {
          title: 'Level',
          dataIndex: 'level',
          key: 'level',
          scopedSlots: {
            customRender: 'level',
          },
          filters: moderatorLevel,
          onFilter: (value, record) => includes(record.moderator.level, value),
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: {
            customRender: 'status',
          },
          filters: moderatorStatus,
          onFilter: (value, record) => includes(record.moderator.status, value),
        },
        {
          title: 'Created at',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: {
            customRender: 'created_at',
          },
        },
        {
          title: 'Sign',
          dataIndex: 'signature',
          key: 'signature',
          scopedSlots: {
            customRender: 'signature',
          },
        },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ].map(item => {
        if (!['operation', 'role', 'status', 'level'].includes(item.key)) {
          return {
            ...item,
            scopedSlots: {
              ...item.scopedSlots,
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
            },
            onFilter: (value, record) => record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value)),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          };
        }
        return item;
      }),
    };
  },
  watch: {
    moderatorList: {
      async handler(val) {
        this.userData = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    empty,
    getRoleInfo(text) {
      text = replace(text, '[', '');
      text = replace(text, ']', '');
      return text;
    },
    getFullName(record) {
      const { firstname, lastname } = record;
      return `${firstname || ''} ${lastname || ''}`.trimLeft();
    },
    getCreatedAt(record) {
      const date = new Date(record.moderator.created_at || Date.now());
      return moment(date).format('MM/DD/YYYY');
    },
    async doInitData() {
      this.moderatorList = await AdminService.moderator.getAll();
    },
    handleCancel() {},
    async handleLevelChange(value, record) {
      this.isLoading = true;

      const { id } = record.moderator;

      await AdminService.moderator.update(id, {
        level: value,
      });
      this.isLoading = false;
    },
    async handleStatusChange(value, record) {
      this.isLoading = true;

      const { id, status } = record.moderator;

      await AdminService.moderator.update(id, {
        status: value,
      });

      const element = document.querySelector(`.select-status-${id}`);
      element.classList.remove(`select-value-${status}`);
      element.classList.add(`select-value-${value}`);

      this.isLoading = false;
    },
    handleReset(clearFilters) {
      clearFilters();
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.moderator.delete(record.moderator.id);

        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.firstname} ${record.lastname} was deleted successfully.`,
        });
        await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },
  },
};
</script>
<style lang="scss">
.select-value-review,
.select-option-review {
  color: #33cacc;
}
.select-value-approved,
.select-option-approved {
  color: #78beff;
}
.select-value-declined,
.select-option-declined {
  color: #eb685f;
}
</style>
